import { SpineEvents } from "../../core/enums/SpineEvents";
import { EquipmentTypeValues, VehicleEquipment } from "./VehicleEquipment";
import { VehicleVillain } from "./VehicleVillain";

export abstract class VehicleEquipmentWeapon extends VehicleEquipment {
  public static events = {
    Firing: 'firing',
    FinishedFiring: 'finishedFiring'
  } as const;

  protected vehicle: VehicleVillain;

  constructor(scene: Phaser.Scene, equipmentType: EquipmentTypeValues, vehicle: VehicleVillain) {
    super(scene, equipmentType)

    this.vehicle = vehicle;

    this.vehicle.CharacterSpine.on(SpineEvents.Start, this.animationStart, this);
    this.vehicle.CharacterSpine.on(SpineEvents.End, this.animationEnd, this);
  }

  public abstract fire(): void;
  public abstract onFinishedFiring(): void;

  protected animationStart(entry: spine.TrackEntry) {
  }

  protected animationEnd(entry: spine.TrackEntry) {
  }
}

